import { nanoid } from "nanoid";
import { useMemo } from "react";

export const useNanoId: typeof nanoid = (...args) =>
  useMemo(() => nanoid(...args), []);
